import React from "react";
import { colors } from "../lib/design";
import spotifyImage from "../images/spotify.png";
import googleImage from "../images/google.png";
import appleImage from "../images/apple_podcasts.jpg";
import stitcherImage from "../images/stitcher.jpg";
import radioPublicImage from "../images/radio_public.jpg";
import youtubeImage from "../images/youtube_social_squircle_red.png";
import YoutubeButton from "../components/lib/youtube_button";
import SpotifyDistribution from "../components/lib/spotify_distribution";
export const reach = {
  large: {
    name: "Large",
    key: "large",
    color: colors.primaryColor,
  },
  medium: {
    name: "Moderate",
    key: "medium",
    color: colors.burgundy,
  },
  small: {
    name: "Small",
    key: "small",
    color: colors.mediumBlue,
  },
};

export const distributionKeyNames = {
  applePodcasts: "applePodcasts",
  spotify: "spotify",
  stitcher: "stitcher",
  youtube: "youtube",
  googlePodcasts: "googlePodcasts",
  radioPublic: "radioPublic",
};

export const distributionKeys = [
  {
    key: distributionKeyNames.applePodcasts,
    name: "Apple Podcasts",
    reach: reach.large,
    disabled: false,
    image: appleImage,
    placeholder: "https://itunes.apple.com/us/podcast/podcast-name/id12345678",
    Instructions: function instruction() {
      return (
        <div>
          <p>
            Apple Podcasts is the largest podcast distribution platform, so it's very important to
            make sure your podcast is distributed there.
          </p>
          <p>
            Follow{" "}
            <a
              href="https://support.redcircle.com/distributing-your-podcast/distributing-your-redcircle-podcast-to-apple-podcasts"
              target="_blank"
              rel="noopener noreferrer">
              these instructions
            </a>{" "}
            to get your show registered. Once that's done, paste the link to apple's podcast page
            here.
          </p>
        </div>
      );
    },
  },
  {
    key: distributionKeyNames.spotify,
    name: "Spotify",
    reach: reach.large,
    disabled: false,
    image: spotifyImage,
    noInput: true,
    placeholder: "https://open.spotify.com/show/aBunchOfCrazyNumbersAndLetters",
    Instructions: function instruction({ showUUID }) {
      return (
        <div>
          <p>
            Spotify has quite a few listeners as well, so let's make sure your show is available
            there.
          </p>
          <p>
            Visit this{" "}
            <a
              href="https://support.redcircle.com/distributing-your-podcast/distributing-your-redcircle-podcast-to-spotify"
              target="_blank"
              rel="noopener noreferrer">
              help page
            </a>{" "}
            for details on how to get your show registered, and then paste a link to your show back
            here.
          </p>
          <SpotifyDistribution showUUID={showUUID} />
        </div>
      );
    },
  },
  {
    key: distributionKeyNames.stitcher,
    name: "Stitcher",
    reach: reach.medium,
    disabled: false,
    image: stitcherImage,
    placeholder: "https://www.stitcher.com/podcast/network-name/show-title",
    Instructions: function instruction() {
      return (
        <div>
          <p>
            Stitcher is a podcast streaming app with its own registry. Stitcher has about 2% of
            podcast plays, so it's worth getting set up.
          </p>
          <p>
            Visit this{" "}
            <a
              href="https://support.redcircle.com/distributing-your-podcast/distributing-your-podcast-to-stitcher"
              target="_blank"
              rel="noopener noreferrer">
              help page
            </a>{" "}
            for details on how to get your show set up with Stitcher. Once you're done, paste your
            stitcher web link here.
          </p>
        </div>
      );
    },
  },
  {
    key: distributionKeyNames.youtube,
    name: "YouTube",
    reach: reach.small,
    image: youtubeImage,
    noInput: true,
    skipValidation: true,
    Instructions: function instruction() {
      return (
        <div>
          <p>
            Connecting your Youtube account allows us to automatically upload videos of your podcast
            episodes when you upload them.
          </p>
          <YoutubeButton />
        </div>
      );
    },
  },
  {
    key: distributionKeyNames.googlePodcasts,
    name: "Google Podcasts",
    reach: reach.medium,
    disabled: true,
    image: googleImage,
    Instructions: function instruction() {
      return (
        <div>
          <p>
            We'll automatically distribute your podcast to Google's apps, it usually takes a few
            days.
          </p>
          <p>
            Once Google picks up the show, this link will start working. No action needed from you!
          </p>
        </div>
      );
    },
  },
  {
    key: distributionKeyNames.radioPublic,
    name: "RadioPublic",
    reach: reach.small,
    disabled: true,
    image: radioPublicImage,
    Instructions: function instruction() {
      return (
        <div>
          <p>RadioPublic is a great podcast app with its own directory.</p>
          <p>We automatically publish your show to RadioPublic, so no action is needed from you.</p>
        </div>
      );
    },
  },
];
